module.exports = __webpack_public_path__ + "img/10_98.ebfe1442.png";